module.exports = __webpack_public_path__ + "media/missionStart.5da19467.mp4";